import { useSignal } from "@preact/signals-react";
import { FormattedMessage as FM } from "react-intl";
import { colorTags } from "../../../theme/colors";

import { useTable } from "storev2/tableStore";
import { cn } from "tools/ui";

const styleBase =
  "lg:py-2 tablet:p-3 md:p-0 md:w-20 lg:w-28 rounded-xl text-xs text-center uppercase p-2";

function StateFilter({ states, model, storeId, field = "state" }) {
  const activeStates = useSignal([]);

  const { reload } = useTable();
  if (!states) return null;

  async function ClickState(state) {
    const activeList = activeStates.value;
    const index = activeList.indexOf(state);
    if (index >= 0) {
      activeList.splice(index, 1);
    } else {
      activeList.push(state);
    }
    activeStates.value = activeList;
    const domain =
      activeList.length > 0 ? [[field, "in", activeList]] : [];
    await reload(storeId, domain);
  }

  return (
    <div className="flex flex-wrap gap-2 my-4 md:text-sm">
      {Object.entries(states).map(([state, color]) => {
        const active = activeStates.value.includes(state);
        return (
          <button
            type="button"
            key={state}
            className={cn(
              styleBase,
              colorTags[color || "slate"],
              active && "ring-2 ring-inset active:scale-95 inline",
            )}
            onClick={() => ClickState(state)}
          >
            <FM id={`${model}.${state}`} />
            {active && <span className="ml-1">✓</span>}
          </button>
        );
      })}
    </div>
  );
}

export default StateFilter;
